export enum StowagePlanShareTypeEnum {
    Private,
    Shared,
}
